module.exports = __webpack_public_path__ + "img/01d.30f588dd.jpg";